import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AwaitableObservable, createAwaitable, createAwaitableApiResponse, createAwaitableResponseBase, extractError } from '../AwaitableObservable';
import { ResponseBase } from '../../models/ResponseBase';
import { ApiResponse } from '../../models/ApiResponse';

@Injectable({ providedIn: 'root' })
export class AlertService {

    private alertSubject = new Subject<any>();

    private _errorTimeout?: any;

    alertState$ = this.alertSubject.asObservable();

    updateAlertState(alertState: any) {
        this.alertSubject.next(alertState);
    }

    error(alertMessage: string = '') {
        if (this._errorTimeout) {
            clearTimeout(this._errorTimeout);
            this._errorTimeout = null;
        }
        const alert = {
            alertMessage: alertMessage ? alertMessage : '',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
        };

        this.alertSubject.next(alert);
    }

    handleError(e: any) {
        if (this._errorTimeout) {
            clearTimeout(this._errorTimeout);
        }
        this._errorTimeout = setTimeout(() => {
                //this.error(typeof e === 'string' ? e : e?.message ?? 'Critical error!')
                this.error(extractError(e));
            },
            100);
    }

    success(alertMessage: string = '') {
        if (this._errorTimeout) {
          clearTimeout(this._errorTimeout);
          this._errorTimeout = null;
        }
        let alert  = {
            alertMessage: alertMessage ? alertMessage : '',
            alertType: 'alert alert-success',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
        };
        this.alertSubject.next(alert);
    }


    createAwaitableApiResponse<T, TResponse extends ApiResponse<T>>(source$: Observable<TResponse>): AwaitableObservable<T> {
        return createAwaitableApiResponse(source$, e => this.handleError(e));
    }

    createAwaitableResponseBase<T extends ResponseBase>(source$: Observable<T>): AwaitableObservable<T> {
        return createAwaitableResponseBase(source$, e => this.handleError(e));
    }
}
